import React, {useEffect, useMemo, memo, useState} from "react";
import {clearHTML, removingAnnotation} from "../../Utils/helpers";
import {useTable, useGlobalFilter, usePagination,useSortBy} from "react-table";
import {Table} from "react-bootstrap";


function SummaryComponent(props) {
    let [lvid] = useState(props.lvid)
    const [TAG_COLORS] = useState({
        Default: 'rgb(82, 125, 219)',
        Potenzial: 'rgb(5, 165, 107)',
        Hinweis: 'rgb(231, 185, 20)',
        Risiko: 'rgb(239, 3, 3)',
        Unresolved: 'rgb(245, 245, 245)',
        flaechen: 'rgb(139, 0, 0)',
        electro: 'rgb(255, 0, 0)',
        ortsbesichtigung: 'rgb(205, 92, 92)',
        laengen: 'rgb(0, 0, 139)',
        Unklar: 'rgb(169,169,169)',
        stundenlohnarbeiten: 'rgb(128,128,128)',
        duebel: 'rgb(0,100,0)',
        beschilderung: 'rgb(0,128,0)',
        montagehoehe: 'rgb(144, 238, 144)',
        sammelbegriffe: 'rgb(128, 0, 128)',
        bohren: 'rgb(255, 165, 0)',
        hls: 'rgb(255, 255, 0)',
        'Nicht Neutral': 'rgb(165, 42, 42)',
        Planungsfabrikat: 'rgb(139, 69, 19)',
        zubehoer: 'rgb(210, 105, 30)'
    });
    let data = useMemo(() => props.data, [props.data]);
    let columns = useMemo(() => props.columns, [props.columns]);
    const globalFilter = React.useCallback((rows, ids, query) => {
        const searchTerm = String(query).toLowerCase();
        return rows.filter((row) => {
            const matches = ids.filter((id) => {
                const rowValue = row.values[id];
                return rowValue !== undefined
                    ? String(rowValue).toLowerCase().includes(searchTerm)
                    : false;
            });

            return matches.length > 0;
        });
    }, []);

    let {
        getTableProps, // table props from react-table
        getTableBodyProps, // table body props from react-table
        headerGroups, // headerGroups, if your table has groupings
        //rows, // rows for the table based on the data passed
        prepareRow, // Prepare the row (this function needs to be called for each row before getting the row props)
        setGlobalFilter,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: {pageIndex, pageSize}

    } = useTable({
            columns,
            data,
            globalFilter
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const handleFilterInputChange = (e) => {
        setGlobalFilter(e.currentTarget.value);
    };

    // const handleDelete = async (o, state, setAnnotations) => {
    //     removingAnnotation(o.unique_id, props.annotationData)
    //     let newData = state.annotations.filter((obj) => obj.unique_id !== o.unique_id);
    //     let newState = state
    //     newState.annotations = newData
    //     setAnnotations(newState);
    //     // Create a new array without the object to delete
    //     // let annotations = await updatedState
    //     // console.log(annotations, "handle")
    //     // console.log(state, "lamba")
    //     // This should log the updated array correctly
    //     // let newState = state
    //     // newState.annotations = annotations
    //     // console.log(typeof setAnnotations, "+")
    //     // setAnnotations(newState);
    //     // Update the state with the new array
    // }
    /***
     * To scroll to the annotation on clicking the table row
     */
    const scrollTotheAnnotation = (row) => {
        let id = row.unique_id
        if (document.getElementById(id) !== null) {
            let mark = document.getElementById(id);
            mark.scrollIntoView({block: 'end', behavior: 'smooth'});
        }
    };


    const handleDelete = async (o, state, setAnnotations) => {
        removingAnnotation(o.unique_id, props.annotationData,lvid)
        let newData = state.annotations.filter((obj) => obj.unique_id !== o.unique_id);
        let newState = state
        newState.annotations = newData
        setAnnotations(newState);

        // Create a new array without the object to delete
        // let annotations = await updatedState
        // console.log(annotations, "handle")
        // console.log(state, "lamba")
        // This should log the updated array correctly
        // let newState = state
        // newState.annotations = annotations
        // console.log(typeof setAnnotations, "+")
        // setAnnotations(newState);
        // Update the state with the new array
    }



    useEffect(async () => {


    }, [])
    return (

        <>
            <input
                name="search"
                placeholder="Search"
                onChange={handleFilterInputChange}
            />
            <Table id={"summaryTable"} {...getTableProps()}>
                <thead>
                {headerGroups.map(headerGroup => (
                    // eslint-disable-next-line react/jsx-key
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            // eslint-disable-next-line react/jsx-key
                            <th {...column.getHeaderProps(column.getSortByToggleProps())}>{column.render("Header")}
                            <span>
                            {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                        </span>
                            </th>
                        ))}
                    </tr>
                ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                    prepareRow(row);
                    return (
                        // eslint-disable-next-line react/jsx-key
                        <tr
                            className="advicesTDTextFormat"
                            style={{background: TAG_COLORS[clearHTML(row.original.norm)]}}
                            onClick={() => {
                                console.log(i)
                                scrollTotheAnnotation(row.original)
                            }
                            }
                            onContextMenu={() => {
                                handleDelete(row.original, props.annotationData, props.setAnnotationData)
                                document.addEventListener('contextmenu', (event) =>
                                {event.preventDefault();
                                if (event.target.tagName === "TR") {
                                    // Remove the clicked row from the table
                                     event.target.remove();
                                    //
                                    }
                                }
                                )
                            }}

                            {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                // eslint-disable-next-line react/jsx-key
                                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                            })}
                        </tr>
                    );
                })}
                </tbody>
            </Table>


            <div className="pagination">
                <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                    {"<<"}
                </button>
                {" "}
                <button onClick={() => previousPage()} disabled={!canPreviousPage}>
                    {"<"}
                </button>
                {" "}
                <button onClick={() => nextPage()} disabled={!canNextPage}>
                    {">"}
                </button>
                {" "}
                <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                    {">>"}
                </button>
                {" "}
                <span>&emsp;
          Page{" "}
                    <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
                <span>&emsp;
          | Go to page:{" "}
                    <input
                        type="number"
                        defaultValue={pageIndex + 1}
                        onChange={(e) => {
                            const page = e.target.value ? Number(e.target.value) - 1 : 0;
                            gotoPage(page);
                        }}
                        style={{width: "100px"}}
                    />
        </span>{" "}
                <select
                    value={pageSize}
                    onChange={(e) => {
                        setPageSize(Number(e.target.value));
                    }}
                >
                    {[5, 20, 50, 100, 200].map((pageSize) => (
                        <option key={pageSize} value={pageSize}>
                            Show {pageSize}
                        </option>
                    ))}
                </select>
                <div>&emsp;&emsp;&emsp;&emsp;<span>{data.length} entries</span></div>
            </div>

        </>
    );
}

export default memo(SummaryComponent);

